import { useEffect, useMemo, useState } from "react";
import useWindowLocation from '../Layout/useWindowLocation';

import './AnchorBar.scss'

export const AnchorBar = ({ anchors }) => {
  const href = useWindowLocation();
  const [focusedAnchor, setFocusedAnchor] = useState(0)

  const handleScroll = useMemo(() => () => {
    if (window.pageYOffset >= anchors[0].ref.current.offsetTop - 90 && window.pageYOffset < anchors[1].ref.current.offsetTop - 90) {
      setFocusedAnchor(0);
    } else if (window.pageYOffset >= anchors[1].ref.current.offsetTop - 90 && window.pageYOffset < anchors[2].ref.current.offsetTop - 90) {
      setFocusedAnchor(1);
    } else if (window.pageYOffset >= anchors[2].ref.current.offsetTop - 90 && window.pageYOffset < anchors[3].ref.current.offsetTop - 90) {
      setFocusedAnchor(2);
    } else if (window.pageYOffset >= anchors[3].ref.current.offsetTop - 90) {
      setFocusedAnchor(3);
    }
  }, [anchors]);

  useEffect(() => {
    const splittedUrl = href.split("#");

    if (splittedUrl[1] === anchors[0].id && anchors[0].ref.current) {
      setTimeout(() => window.scrollTo({ top: anchors[0].ref.current.offsetTop - 90, behavior: "smooth" }), 100);
    } else if (splittedUrl[1] === anchors[1].id && anchors[1].ref.current) {
      setTimeout(() => window.scrollTo({ top: anchors[1].ref.current.offsetTop - 90, behavior: "smooth" }), 100);
    } else if (splittedUrl[1] === anchors[2].id && anchors[2].ref.current) {
      setTimeout(() => window.scrollTo({ top: anchors[2].ref.current.offsetTop - 90, behavior: "smooth" }), 100);
    } else if (splittedUrl[1] === anchors[3].id && anchors[3].ref.current) {
      setTimeout(() => window.scrollTo({ top: anchors[3].ref.current.offsetTop - 90, behavior: "smooth" }), 100);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [anchors, href])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  return (
    <div className="anchor-bar">
      <div className="anchor-bar-wrapper">
        <a className="anchor-bar--step" href={`#${anchors[0].id}`}>
          <span className={`anchor-bar--step-number__${focusedAnchor === 0 ? "focused" : "normal"}`}>1</span>
          <span className="anchor-bar--step-name">{anchors[0].title}</span>
        </a>

        <a className="anchor-bar--step" href={`#${anchors[1].id}`}>
          <span className={`anchor-bar--step-number__${focusedAnchor === 1 ? "focused" : "normal"}`}>2</span>
          <span className="anchor-bar--step-name">{anchors[1].title}</span>
        </a>

        <a className="anchor-bar--step" href={`#${anchors[2].id}`}>
          <span className={`anchor-bar--step-number__${focusedAnchor === 2 ? "focused" : "normal"}`}>3</span>
          <span className="anchor-bar--step-name">{anchors[2].title}</span>
        </a>

        <a className="anchor-bar--step" href={`#${anchors[3].id}`}>
          <span className={`anchor-bar--step-number__${focusedAnchor === 3 ? "focused" : "normal"}`}>4</span>
          <span className="anchor-bar--step-name">{anchors[3].title}</span>
        </a>
      </div>
    </div>
  )
};

export default AnchorBar